import { useCallback } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";

const useConfirmationTokenPurchase = () => {
  const stripe = useStripe();
  const elements = useElements();

  return useCallback(
    async ({ submit, tokenParams = {}, formatError }) => {
      if (!stripe || !elements) {
        throw formatError("The payment form is still loading. Please try again.");
      }

      const { error: submitError } = await elements.submit();
      if (submitError) throw formatError(submitError.message);

      const { confirmationToken, error: tokenError } = await stripe.createConfirmationToken({
        elements,
        params: tokenParams
      });
      if (tokenError) throw formatError(tokenError.message);

      const purchaseResponse =
        (await submit({ stripe_confirmation_token: confirmationToken.id })) || {};
      if (!purchaseResponse.requiresAction) return purchaseResponse;

      const { error: actionError } = await stripe.handleNextAction({
        clientSecret: purchaseResponse.clientSecret
      });
      if (actionError) throw formatError(actionError.message);

      return submit({
        stripe_intent_id: purchaseResponse.intentId,
        stripe_intent_campaign_id: purchaseResponse.campaignId
      });
    },
    [stripe, elements]
  );
};

export default useConfirmationTokenPurchase;
